import styled from 'styled-components';
import { Box, Button } from '@rsos/base-components';
import { Accordion } from '@rsos/components/capstone/base';
import { Container } from '@rsos/components/capstone/base/Button/Button.styles';

export const OFFSET_HEIGHT = 92; // height of the header above the start button

export const StartChatContainer = styled(Box).attrs({
  height: '100%',
  horizontal: true,
  mt: '8px',
  width: '100%',
  px: '8px',
})``;

export const ChatAccordion = styled(Accordion).attrs({
  headerIcon: 'chevron',
  interactionType: 'button',
  noBorder: true,
  padding: '0',
  width: '100%',
  btnSize: 'med',
  btnPx: '10px',
})``;

export const ChatAccordionHeaderContainer = styled(Box).attrs({
  alignSelf: 'center',
  horizontal: true,
  gridColumnGap: '8px',
  width: '100%',
})``;

export const StartChatButton = styled(Button).attrs({
  btnType: 'tertiary',
  noMargin: true,
  size: 'med',
  grow: true,
  width: '100%',
})`
  border-radius: 5px 0 0 5px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const StartChatButtonNext = styled(Button).attrs({
  btnType: 'tertiary',
  noMargin: true,
  size: 'med',
  grow: true,
  width: '100%',
})`
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }

  /* AccordionContainer -> Box:last-child above targets this component. use !important */
  // border-radius: 5px 0 0 5px !important;
  border-radius: 5px 0 0 5px;

  // Button.styles Container
  ${Container} {
    grid-column-gap: 4px;
  }
`;

export const StartChatButtonNoAccordion = styled(StartChatButton)`
  border-radius: 5px;
  > div {
    grid-column-gap: 4px;
  }
`;
